/**
 * Weekend-skipping date stepping shared by the calendar surfaces (old
 * HeaderToolbar ports the same math; MobiliHeaderToolbar and the Mobili
 * keyboard paging use THIS copy). Contract: keyboardSpec.ts → datePage.
 */
import moment from "moment";

/** One day forward, landing on Monday when the step hits the weekend. */
export const nextDateStr = (dateStr: string, days = 1): string => {
  const next = moment(dateStr).add(days, "day");
  if (next.day() === 6) next.add(2, "day"); // skip Saturday
  if (next.day() === 0) next.add(1, "day"); // skip Sunday
  return next.format("YYYY-MM-DD");
};

/** One day back, landing on Friday when the step hits the weekend. */
export const previousDateStr = (dateStr: string, days = 1): string => {
  const prev = moment(dateStr).subtract(days, "day");
  if (prev.day() === 0) prev.subtract(2, "day"); // skip Sunday
  if (prev.day() === 6) prev.subtract(1, "day"); // skip Saturday
  return prev.format("YYYY-MM-DD");
};
